import moment from 'moment';

const getters = {
    formatOpenTs(state) {
        return state.openResult.openTs ? moment(state.openResult.openTs).format('YYYY年MM月DD日') : '';
    },
    formatExpiredTs(state) {
        return state.openResult.expiredTs ? moment(state.openResult.expiredTs).format('YYYY年MM月DD日') : '';
    },
    formatEnabledCode(state) {
        return `${state.openResult.enabledCode.slice(0, 3)}******${state.openResult.enabledCode.slice(-3)}`;
    },
    formatOpenedMobile(state) {
        return `${state.openResult.openedMobile.slice(0, 4)}-${state.openResult.openedMobile.slice(4, 7)}-${state.openResult.openedMobile.slice(7)}`;
    },
    formatProductName(state) {
        return `${state.openResult.productName}`;
    },
};

export default getters;